<dialog id="studentFormModal" class="modal" #modal appPreventEscClose>
    <div class="modal-box relative p-0 w-11/12 max-w-2xl max-h-[90vh] overflow-hidden flex flex-col">


        <div class="py-5 relative flex flex-col flex-1 min-h-0">

            <div class="flex justify-between items-center px-5">
                <h2 class="text-lg font-semibold ">{{type == 'edit' ? 'Edit' : 'Create New'}} Student</h2>
                <button class="btn btn-sm btn-circle btn-ghost" (click)="closeModal()"><i
                        class="ri-close-line"></i></button>
            </div>

            <div role="tablist" class="tabs tabs-bordered px-3 capitalize mt-3 shrink-0">
                @for (i of tabs; track $index) {
                <button [disabled]="i.isLock || isFetching" role="tab" (click)="currentTab = i.value"
                    class="tab hover:rounded-t-md" [ngClass]="{'tab-active': currentTab == i.value}">{{i.name}}</button>
                }
            </div>

<div class="mt-5 px-7 py-3 flex-1 min-h-0 overflow-y-auto">
                @defer (when isDataReady) {
                <ng-container [ngSwitch]="currentTab">
                    <!-- personal details -->
                    <form [formGroup]="studentPersonalDetailsForm"
                        *ngSwitchCase="'personal'" action="" class="flex flex-col gap-5 min-h-full">
                        <div class=" grid grid-cols-1 md:grid-cols-2 gap-5">

                            <!-- Profile -->
                            <div class=" col-span-1 md:col-span-2">
                                <div class="col-span-1 md:col-span-2 flex items-center gap-2 cursor-pointer"
                                    (click)="file.click()">
                                    <div class="avatar"
                                        [ngClass]="{'ring-zinc-200 ring-offset-base-100 rounded-[1.8rem] ring ring-offset-2':profile_pic != null}">
                                        <div class="mask mask-squircle w-24 bg-zinc-100 border">
                                            <span *ngIf="profile_pic == null"
                                                class="w-full h-full flex flex-col items-center justify-center">
                                                <i class="ri-image-circle-ai-fill text-3xl"></i>
                                                <small class="text-zinc-500">Profile</small>
                                            </span>

                                            <img *ngIf="profile_pic != null" class="w-full h-full object-cover"
                                                src="{{ profile_pic }}" />
                                        </div>
                                    </div>

                                    <div class="ml-3">
                                        <p class="font-semibold">Upload Profile Photo</p>
                                        <p class="text-sm text-gray-500">File size must be under 2MB with 500×500
                                            dimensions.</p>
                                    </div>
                                </div>
                                <input type="file" #file class="hidden" id="file" accept="image/*"
                                    (change)="setProfilePic($event)" />
                            </div>
                            <!-- Profile -->
                            <label class="form-control col-span-1 w-full ">
                                <div class="label">
                                    <span class="label-text req">First Name</span>
                                </div>
                                <input type="text" formControlName="first_name" placeholder=""
                                    [ngClass]="{'error': studentPersonalDetailsForm.get('first_name')?.invalid && studentPersonalDetailsForm.get('first_name')?.touched}"
                                    class="input input-bordered w-full " />
                                @if (studentPersonalDetailsForm.get('first_name')?.invalid &&
                                studentPersonalDetailsForm.get('first_name')?.touched) {
                                <span class="text-red-500 text-xs">{{ getControlError(studentPersonalDetailsForm.get('first_name'), 'First name', { pattern: 'First name can contain only letters and spaces' }) }}</span>
                                }
                            </label>

                            <label class="form-control col-span-1 w-full ">
                                <div class="label">
                                    <span class="label-text req">Last Name</span>
                                </div>
                                <input type="text" formControlName="last_name" placeholder=""
                                    [ngClass]="{'error': studentPersonalDetailsForm.get('last_name')?.invalid && studentPersonalDetailsForm.get('last_name')?.touched}"
                                    class="input input-bordered w-full " />
                                @if (studentPersonalDetailsForm.get('last_name')?.invalid &&
                                studentPersonalDetailsForm.get('last_name')?.touched) {
                                <span class="text-red-500 text-xs">{{ getControlError(studentPersonalDetailsForm.get('last_name'), 'Last name', { pattern: 'Last name can contain only letters and spaces' }) }}</span>
                                }
                            </label>

                            <label class="form-control col-span-1 w-full ">
                                <div class="label">
                                    <span class="label-text req">Email</span>
                                </div>
                                <input type="email" formControlName="email_id" placeholder=""
                                    [ngClass]="{'error': studentPersonalDetailsForm.get('email_id')?.invalid && studentPersonalDetailsForm.get('email_id')?.touched}"
                                    class="input input-bordered w-full " />

                                @if (studentPersonalDetailsForm.get('email_id')?.invalid &&
                                studentPersonalDetailsForm.get('email_id')?.touched) {
                                <span class="text-red-500 text-xs">{{ getControlError(studentPersonalDetailsForm.get('email_id'), 'Email', { 
                                  required: 'Email is required', 
                                  maxlength: 'Email ID cannot exceed 100 characters',
                                  pattern: 'Please enter a valid email address.' 
                                }) }}</span>
                                }
                            </label>

                            <label class="form-control col-span-1 w-full ">
                                <div class="label">
                                    <span class="label-text req">Phone Number</span>
                                </div>
                                <input
                                    formControlName="mobile"
                                    type="tel"
                                    inputmode="numeric"
                                    autocomplete="tel"
                                    placeholder=""
                                    [ngClass]="{'error': studentPersonalDetailsForm.get('mobile')?.invalid && studentPersonalDetailsForm.get('mobile')?.touched}"
                                    class="input input-bordered w-full "
                                    (keypress)="$event.charCode >= 48 && $event.charCode <= 57" />

                                @if (studentPersonalDetailsForm.get('mobile')?.invalid && studentPersonalDetailsForm.get('mobile')?.touched) {
                                <span class="text-red-500 text-xs">{{ getControlError(studentPersonalDetailsForm.get('mobile'), 'Phone number', { pattern: 'Enter a valid 10-digit phone number' }) }}</span>
                                }

                                @if (studentPersonalDetailsForm.get('mobile')?.errors?.['mobileEmailMismatch']) {
                                <span class="text-red-500 text-xs">{{ studentPersonalDetailsForm.get('mobile')?.errors?.['mobileEmailMismatch'] }}</span>
                                }

                            </label>

                            <div class="input-date ">
                                <label class="form-control col-span-1 w-full ">
                                    <div class="label">
                                        <span class="label-text req">Date of Birth</span>
                                    </div>
                                    <input type="date" formControlName="date_of_birth" placeholder="" #dobInput
                                        (focus)="dobInput.click()"
                                        [max]="todayDate"
                                        [ngClass]="{'error': studentPersonalDetailsForm.get('date_of_birth')?.invalid && studentPersonalDetailsForm.get('date_of_birth')?.touched}"
                                        class="input input-bordered w-full " />
                                    @if (studentPersonalDetailsForm.get('date_of_birth')?.invalid &&
                                    studentPersonalDetailsForm.get('date_of_birth')?.touched) {
                                    <span class="text-red-500 text-xs">{{ getControlError(studentPersonalDetailsForm.get('date_of_birth'), 'Date of birth', { invalidDob: 'Enter a valid past date of birth' }) }}</span>
                                    }
                                </label>
                            </div>

                            <label class="form-control col-span-1 w-full ">
                                <div class="label">
                                    <span class="label-text">Departments</span>
                                </div>
                                <select (change)="setFields($event, 'department')" formControlName="department_id"
                                    class="select select-bordered w-full ">
                                    <option value="null">Choose Department</option>
                                    @for (i of departments; track $index) {
                                    <option [value]="i.id">{{i.department_name}}</option>
                                    }
                                </select>
                            </label>

                            <label class="form-control col-span-1 w-full ">
                                <div class="label">
                                    <span class="label-text">Class</span>
                                </div>
                                <select (change)="setFields($event, 'class')" formControlName="class_id"
                                    class="select select-bordered w-full ">
                                    <option value="null">Choose Class</option>
                                    @for (i of classes; track $index) {
                                    <option [value]="i.id">{{i.class_name}}</option>
                                    }
                                </select>
                            </label>

                            <label class="form-control col-span-1 w-full ">
                                <div class="label">
                                    <span class="label-text">Batch</span>
                                </div>
                                <select formControlName="batch_id" class="select select-bordered w-full ">
                                    <option value="null">Choose Batch</option>
                                    @for (i of batches; track $index) {
                                    <option [value]="i.id">{{i.batch_name}}</option>
                                    }

                                </select>
                            </label>

                            <label class="form-control col-span-1 w-full ">
                                <div class="label">
                                    <span class="label-text">Academic Year</span>
                                </div>
                                <select formControlName="academic_year" class="select select-bordered w-full ">
                                    <option value="null">Choose Academic Year</option>
                                    @for (i of (academicYears$ | async).data || []; track $index) {
                                    <option [value]="i.id">{{i.alias}}</option>
                                    }

                                </select>
                            </label>

                            <div class="divider divider-start col-span-full">Social Platforms</div>

                            <div class="col-span-full">
                                <label class=" input input-bordered flex items-center gap-2"
                                    [ngClass]="{'error': studentPersonalDetailsForm.get('linkedin_handle')?.invalid && studentPersonalDetailsForm.get('linkedin_handle')?.touched}">
                                    <i class="ri-linkedin-box-fill"></i>
                                    <span class="w-20 font-semibold text-sm">Linkedin</span>
                                    <input formControlName="linkedin_handle" type="text" class="grow"
                                        placeholder="Profile Link" />
                                </label>
                                @if(studentPersonalDetailsForm.get('linkedin_handle')?.invalid &&
                                studentPersonalDetailsForm.get('linkedin_handle')?.touched) {
                                <span class="text-red-500 text-xs">{{ getControlError(studentPersonalDetailsForm.get('linkedin_handle'), 'Linkedin profile link') }}</span>
                                }
                            </div>

                            <div class="col-span-full">
                                <label class=" input input-bordered flex items-center gap-2"
                                    [ngClass]="{'error': studentPersonalDetailsForm.get('instagram_handle')?.invalid && studentPersonalDetailsForm.get('instagram_handle')?.touched}">
                                    <i class="ri-instagram-line"></i>
                                    <span class="w-20 font-semibold text-sm">Instagram</span>
                                    <input formControlName="instagram_handle" type="text" class="grow"
                                        placeholder="Profile Link" />
                                </label>
                                @if (studentPersonalDetailsForm.get('instagram_handle')?.invalid &&
                                studentPersonalDetailsForm.get('instagram_handle')?.touched) {
                                <span class="text-red-500 text-xs">{{ getControlError(studentPersonalDetailsForm.get('instagram_handle'), 'Instagram profile link') }}</span>
                                }
                            </div>

                            <div class="col-span-full">
                                <label class=" input input-bordered flex items-center gap-2"
                                    [ngClass]="{'error': studentPersonalDetailsForm.get('twitter_handle')?.invalid && studentPersonalDetailsForm.get('twitter_handle')?.touched}">
                                    <i class="ri-twitter-x-line"></i>
                                    <span class="w-20 font-semibold text-sm">Twitter</span>
                                    <input formControlName="twitter_handle" type="text" class="grow"
                                        placeholder="Profile Link" />
                                </label>
                                @if (studentPersonalDetailsForm.get('twitter_handle')?.invalid &&
                                studentPersonalDetailsForm.get('twitter_handle')?.touched) {
                                <span class="text-red-500 text-xs">{{ getControlError(studentPersonalDetailsForm.get('twitter_handle'), 'Twitter profile link') }}</span>
                                }
                            </div>




                        </div>
                    </form>
                    <div *ngSwitchCase="'personal'" class="shrink-0 flex justify-end bg-white gap-x-3 py-2 border-t border-slate-200">
                        <button type="button" class="btn rounded-full btn-sm px-5" (click)="goToAddressTab()"
                            [disabled]="isreqSending">Next</button>
                    </div>
                    <!-- personal details -->
                    <!-- Address Details -->
                    <form [formGroup]="studentAddressDetailsForm"
                        *ngSwitchCase="'address'" action="" class="flex flex-col gap-5 min-h-full">

                        <p class="font-semibold underline">Current Address</p>

                        <div class=" grid grid-cols-1 md:grid-cols-2 gap-5" [formGroup]="currentAddress">

                            <label class="form-control col-span-1 w-full ">
                                <div class="label">
                                    <span class="label-text req">Address</span>
                                </div>
                                <input formControlName="address" type="text" placeholder=""
                                    [ngClass]="{'error': currentAddress.get('address')?.invalid && currentAddress.get('address')?.touched}"
                                    class="input input-bordered w-full " />
                                @if (currentAddress.get('address')?.invalid && currentAddress.get('address')?.touched) {
                                <span class="text-red-500 text-xs">{{ getControlError(currentAddress.get('address'), 'Address') }}</span>
                                }
                            </label>

                            <label class="form-control col-span-1 w-full ">
                                <div class="label">
                                    <span class="label-text req">City</span>
                                </div>
                                <input formControlName="city" type="text" placeholder=""
                                    [ngClass]="{'error': currentAddress.get('city')?.invalid && currentAddress.get('city')?.touched}"
                                    class="input input-bordered w-full " />
                                @if (currentAddress.get('city')?.invalid && currentAddress.get('city')?.touched) {
                                <span class="text-red-500 text-xs">{{ getControlError(currentAddress.get('city'), 'City') }}</span>
                                }
                            </label>

                            <label class="form-control col-span-1 w-full ">
                                <div class="label">
                                    <span class="label-text req">District</span>
                                </div>
                                <input formControlName="district" type="text" placeholder=""
                                    [ngClass]="{'error': currentAddress.get('district')?.invalid && currentAddress.get('district')?.touched}"
                                    class="input input-bordered w-full " />
                                @if (currentAddress.get('district')?.invalid && currentAddress.get('district')?.touched)
                                {
                                <span class="text-red-500 text-xs">{{ getControlError(currentAddress.get('district'), 'District') }}</span>
                                }
                            </label>

                            <label class="form-control col-span-1 w-full ">
                                <div class="label">
                                    <span class="label-text req ">State</span>
                                </div>
                                <input formControlName="state" type="text" placeholder=""
                                    [ngClass]="{'error': currentAddress.get('state')?.invalid && currentAddress.get('state')?.touched}"
                                    class="input input-bordered w-full " />
                                @if (currentAddress.get('state')?.invalid && currentAddress.get('state')?.touched) {
                                <span class="text-red-500 text-xs">{{ getControlError(currentAddress.get('state'), 'State') }}</span>
                                }
                            </label>

                            <label class="form-control col-span-1 w-full ">
                                <div class="label">
                                    <span class="label-text req">Pincode</span>
                                </div>
                                <input formControlName="pincode" type="number"  placeholder=""
                                    [ngClass]="{'error': currentAddress.get('pincode')?.invalid && currentAddress.get('pincode')?.touched}"
                                    class="input input-bordered w-full " />
                                @if (currentAddress.get('pincode')?.invalid && currentAddress.get('pincode')?.touched) {
                                <span class="text-red-500 text-xs">{{ getControlError(currentAddress.get('pincode'), 'Pincode', { pattern: 'Enter a valid 6-digit pincode' }) }}</span>
                                }
                            </label>

                            <label class="form-control col-span-1 w-full ">
                                <div class="label">
                                    <span class="label-text req">Country</span>
                                </div>
                                <input formControlName="country" type="text" placeholder=""
                                    [ngClass]="{'error': currentAddress.get('country')?.invalid && currentAddress.get('country')?.touched}"
                                    class="input input-bordered w-full " />
                                @if (currentAddress.get('country')?.invalid && currentAddress.get('country')?.touched) {
                                <span class="text-red-500 text-xs">{{ getControlError(currentAddress.get('country'), 'Country') }}</span>
                                }
                            </label>

                        </div>

                        <hr class="my-3">

                        <p class="font-semibold underline">Permanant Address</p>
                        <div class="flex items-center gap-2">
                            <input type="checkbox" class="checkbox checkbox-sm" type="checkbox"
                                formControlName="sameAsCurrent" />
                            <label for="">Use same as current Address</label>
                        </div>

                        <div class=" grid grid-cols-1 md:grid-cols-2 gap-5" [formGroup]="permanentAddress">

                            <label class="form-control col-span-1 w-full ">
                                <div class="label">
                                    <span class="label-text req">Address</span>
                                </div>
                                <input formControlName="address" type="text" placeholder=""
                                    [ngClass]="{'error': permanentAddress.get('address')?.invalid && permanentAddress.get('address')?.touched}"
                                    class="input input-bordered w-full " />
                                @if (permanentAddress.get('address')?.invalid &&
                                permanentAddress.get('address')?.touched) {
                                <span class="text-red-500 text-xs">{{ getControlError(permanentAddress.get('address'), 'Address') }}</span>
                                }
                            </label>

                            <label class="form-control col-span-1 w-full ">
                                <div class="label">
                                    <span class="label-text req">City</span>
                                </div>
                                <input formControlName="city" type="text" placeholder=""
                                    [ngClass]="{'error': permanentAddress.get('city')?.invalid && permanentAddress.get('city')?.touched}"
                                    class="input input-bordered w-full " />
                                @if (permanentAddress.get('city')?.invalid && permanentAddress.get('city')?.touched) {
                                <span class="text-red-500 text-xs">{{ getControlError(permanentAddress.get('city'), 'City') }}</span>
                                }
                            </label>

                            <label class="form-control col-span-1 w-full ">
                                <div class="label">
                                    <span class="label-text req">District</span>
                                </div>
                                <input formControlName="district" type="text" placeholder=""
                                    [ngClass]="{'error': permanentAddress.get('district')?.invalid && permanentAddress.get('district')?.touched}"
                                    class="input input-bordered w-full " />
                                @if (permanentAddress.get('district')?.invalid &&
                                permanentAddress.get('district')?.touched)
                                {
                                <span class="text-red-500 text-xs">{{ getControlError(permanentAddress.get('district'), 'District') }}</span>
                                }
                            </label>

                            <label class="form-control col-span-1 w-full ">
                                <div class="label">
                                    <span class="label-text req ">State</span>
                                </div>
                                <input formControlName="state" type="text" placeholder=""
                                    [ngClass]="{'error': permanentAddress.get('state')?.invalid && permanentAddress.get('state')?.touched}"
                                    class="input input-bordered w-full " />
                                @if (permanentAddress.get('state')?.invalid && permanentAddress.get('state')?.touched) {
                                <span class="text-red-500 text-xs">{{ getControlError(permanentAddress.get('state'), 'State') }}</span>
                                }
                            </label>

                            <label class="form-control col-span-1 w-full ">
                                <div class="label">
                                    <span class="label-text req">Pincode</span>
                                </div>
                                <input formControlName="pincode" type="text" maxlength="6" placeholder=""
                                    [ngClass]="{'error': permanentAddress.get('pincode')?.invalid && permanentAddress.get('pincode')?.touched}"
                                    class="input input-bordered w-full " />
                                @if (permanentAddress.get('pincode')?.invalid &&
                                permanentAddress.get('pincode')?.touched) {
                                <span class="text-red-500 text-xs">{{ getControlError(permanentAddress.get('pincode'), 'Pincode', { pattern: 'Enter a valid 6-digit pincode' }) }}</span>
                                }
                            </label>

                            <label class="form-control col-span-1 w-full ">
                                <div class="label">
                                    <span class="label-text req">Country</span>
                                </div>
                                <input formControlName="country" type="text" placeholder=""
                                    [ngClass]="{'error': permanentAddress.get('country')?.invalid && permanentAddress.get('country')?.touched}"
                                    class="input input-bordered w-full " />
                                @if (permanentAddress.get('country')?.invalid &&
                                permanentAddress.get('country')?.touched) {
                                <span class="text-red-500 text-xs">{{ getControlError(permanentAddress.get('country'), 'Country') }}</span>
                                }
                            </label>

                        </div>
                    </form>
                    <div *ngSwitchCase="'address'" class="shrink-0 flex justify-end items-center bg-white gap-x-3 py-2 border-t border-slate-200">
                        <button type="button" (click)="currentTab = 'personal'" class="btn rounded-full btn-sm px-5"
                            [disabled]="isreqSending">Back</button>
                        <button type="button" (click)="goToParentTab()" class="btn rounded-full btn-sm px-5"
                            [disabled]="isreqSending">Next</button>
                    </div>
                    <!-- Address Details -->
                    <!-- parent details -->
                    <form [formGroup]="studentParentDetailsForm" (ngSubmit)="saveStudentLastTab()"
                        *ngSwitchCase="'parent'" action="" class="flex flex-col gap-5 min-h-full">

                        <div class=" grid grid-cols-1 md:grid-cols-2 gap-5">

                            <label class="form-control col-span-1 md:col-span-2 w-full ">
                                <div class="label">
                                    <span class="label-text req">Full Name</span>
                                </div>
                                <input formControlName="parent_name" type="text" placeholder=""
                                    [ngClass]="{'error': studentParentDetailsForm.get('parent_name')?.invalid && studentParentDetailsForm.get('parent_name')?.touched}"
                                    class="input input-bordered w-full " />
                                @if (studentParentDetailsForm.get('parent_name')?.invalid &&
                                studentParentDetailsForm.get('parent_name')?.touched) {
                                <span class="text-red-500 text-xs">{{ getControlError(studentParentDetailsForm.get('parent_name'), 'Parent full name', { pattern: 'Parent full name can contain only letters and spaces' }) }}</span>
                                }
                            </label>

                            <label class="form-control col-span-1 w-full ">
                                <div class="label">
                                    <span class="label-text">Email</span>
                                </div>
                                <input formControlName="email_id" type="email" placeholder=""
                                    [ngClass]="{'error': studentParentDetailsForm.get('email_id')?.invalid && studentParentDetailsForm.get('email_id')?.touched}"
                                    class="input input-bordered w-full " />
                                @if (studentParentDetailsForm.get('email_id')?.invalid &&
                                studentParentDetailsForm.get('email_id')?.touched) {
                                <span class="text-red-500 text-xs">{{ getControlError(studentParentDetailsForm.get('email_id'), 'Email', { required: 'Email is required', pattern: 'Please enter a valid email address.' }) }}</span>
                                }
                            </label>

                            <label class="form-control col-span-1 w-full ">
                                <div class="label">
                                    <span class="label-text req ">Phone Number</span>
                                </div>
                                <input
                                    formControlName="mobile"
                                    type="number"
                                    inputmode="numeric"
                                    autocomplete="tel"
                                    placeholder=""
                                    [ngClass]="{'error': studentParentDetailsForm.get('mobile')?.invalid && studentParentDetailsForm.get('mobile')?.touched}"
                                    class="input input-bordered w-full "
                                    (keypress)="$event.charCode >= 48 && $event.charCode <= 57" />
                                @if (studentParentDetailsForm.get('mobile')?.invalid &&
                                studentParentDetailsForm.get('mobile')?.touched) {
                                <span class="text-red-500 text-xs">{{ getControlError(studentParentDetailsForm.get('mobile'), 'Phone number', { pattern: 'Enter a valid 10-digit phone number' }) }}</span>
                                }
                            </label>


                            <label class="form-control col-span-1 w-full ">
                                <div class="label">
                                    <span class="label-text req">Relation with student</span>
                                </div>
                                <select formControlName="relation_with_student"
                                    [ngClass]="{'error': studentParentDetailsForm.get('relation_with_student')?.invalid && studentParentDetailsForm.get('relation_with_student')?.touched}"
                                    class="select select-bordered w-full ">
                                    <option disabled selected>Choose Relation with student</option>
                                    @for (i of relationshipList; track $index) {
                                    <option value="{{i.value}}">{{i.label}}</option>
                                    }
                                </select>
                                @if (studentParentDetailsForm.get('relation_with_student')?.invalid &&
                                studentParentDetailsForm.get('relation_with_student')?.touched) {
                                <span class="text-red-500 text-xs">{{ getControlError(studentParentDetailsForm.get('relation_with_student'), 'Relation with student') }}</span>
                                }
                            </label>

                        </div>

                        <hr class="my-3">
                        <p class="font-semibold underline">Occupation</p>

                        <div class=" grid grid-cols-1 md:grid-cols-2 gap-5">

                            <label class="form-control col-span-1 md:col-span-2 w-full ">
                                <div class="label">
                                    <span class="label-text">Name</span>
                                </div>
                                <input formControlName="occupational_name" type="text" placeholder=""
                                    [ngClass]="{'error': studentParentDetailsForm.get('occupational_name')?.invalid && studentParentDetailsForm.get('occupational_name')?.touched}"
                                    class="input input-bordered w-full " />
                                @if (studentParentDetailsForm.get('occupational_name')?.invalid &&
                                studentParentDetailsForm.get('occupational_name')?.touched) {
                                <span class="text-red-500 text-xs">{{ getControlError(studentParentDetailsForm.get('occupational_name'), 'Occupation name', { 
                                 
                                  minlength: 'Occupation name must be at least 2 characters',
                                  maxlength: 'Occupation name cannot exceed 255 characters',
                                  pattern: 'Occupation name can contain only letters, numbers, spaces and punctuation' 
                                }) }}</span>
                                }
                            </label>

                            <label class="form-control col-span-1 w-full ">
                                <div class="label">
                                    <span class="label-text">Email</span>
                                </div>
                                <input formControlName="occupational_email" type="email" placeholder=""
                                    [ngClass]="{'error': studentParentDetailsForm.get('occupational_email')?.invalid && studentParentDetailsForm.get('occupational_email')?.touched}"
                                    class="input input-bordered w-full " />
                                @if (studentParentDetailsForm.get('occupational_email')?.invalid &&
                                studentParentDetailsForm.get('occupational_email')?.touched) {
                                <span class="text-red-500 text-xs">{{ getControlError(studentParentDetailsForm.get('occupational_email'), 'Email', { pattern: 'Please enter a valid email address.' }) }}</span>
                                }
                            </label>

                            <label class="form-control col-span-1 w-full ">
                                <div class="label">
                                    <span class="label-text">Phone Number</span>
                                </div>
                                <input formControlName="occupational_mobile" type="number" placeholder=""
                                    inputmode="numeric"
                                    autocomplete="tel"
                                    [ngClass]="{'error': studentParentDetailsForm.get('occupational_mobile')?.invalid && studentParentDetailsForm.get('occupational_mobile')?.touched}"
                                    class="input input-bordered w-full " />
                                @if (studentParentDetailsForm.get('occupational_mobile')?.invalid &&
                                studentParentDetailsForm.get('occupational_mobile')?.touched) {
                                <span class="text-red-500 text-xs">{{ getControlError(studentParentDetailsForm.get('occupational_mobile'), 'Phone number', {  pattern: 'Enter a valid 10-digit phone number' }) }}</span>
                                }
                            </label>

                        </div>
                    </form>
                    <div *ngSwitchCase="'parent'" class="shrink-0 flex justify-end bg-white gap-3 py-2 border-t border-slate-200">
                        <button type="button" (click)="currentTab = 'address'" class="btn rounded-full btn-sm px-5"
                            [disabled]="isreqSending">Back</button>
                        <button type="submit" class="btn btn-sm capitalize btn-primary" [disabled]="isreqSending" (click)="saveStudentLastTab()">
                            @if (isreqSending) {
                            <i class="ri-loader-2-line animate-spin"></i>
                            }@else {
                            <span>Save</span>
                            }
                        </button>
                    </div>
                    <!-- parent details -->
                </ng-container>
                } @placeholder {
                <app-loader></app-loader>
                }
            </div>

        </div>

    </div>
</dialog>
